import { useState } from "react";
import { DateRangeFilterOption } from "./types";

export const useDateRangeFilter = () => {
  const [dateRange, setDateRange] = useState<
    DateRangeFilterOption["filterData"]
  >({});

  const handleFromDateChange = (date: string | undefined) => {
    setDateRange((prev) => ({ ...prev, fromDate: date }));
  };

  const handleToDateChange = (date: string | undefined) => {
    setDateRange((prev) => ({ ...prev, toDate: date }));
  };

  const handleRemoveDateFilter = () => {
    setDateRange({ fromDate: undefined, toDate: undefined });
  };

  const isRangeSelected = Boolean(dateRange?.fromDate && dateRange?.toDate);

  return {
    dateRange,
    isRangeSelected,
    handleFromDateChange,
    handleToDateChange,
    handleRemoveDateFilter,
  };
};
